import React, { useMemo } from "react";

// Kapsam seçicisinin TAMAMI `dashboard.scope` yetkisine bağlıdır (page'den
// canSeeScope ile gelir). Segmentler ayrıca `dealers.read`/`customers.read`
// istemez: onlar firma LİSTESİ yetkileridir (Bayilerim/Müşterilerim sayfaları),
// dashboard'da bayinin kendi ağının toplamını görmesiyle ilgisi yok. Önceki
// sürümde bu iki yetkiye bağlıydı ve yetkisi olmayan bayide seçici tamamen
// kayboluyordu (2026-08-12 ekran görüntüsü).
//
// "bayilerim" yalnızca alt bayisi OLAN bayide gösterilir: sunucuda
// "bayilerim" = kendisi + alt bayiler; alt bayi yoksa "Bayim" ile birebir
// aynı sonucu döndürür (bkz. getDealerFirmIds).
const ALL_SCOPES = [
  { key: "tumu", label: "Tümü" },
  { key: "bayim", label: "Bayim" },
  { key: "bayilerim", label: "Bayilerim", needsSubDealer: true },
  { key: "musterilerim", label: "Müşterilerim" },
];

/**
 * Bayi dashboard'u kapsam seçicisi (Tümü / Bayim / Bayilerim / Müşterilerim) —
 * soft segment kontrolü: gri track üstünde beyaz aktif segment. Tüketim
 * kartında dönem butonlarının (Bugün / Dün / Bu Hafta…) altında durur.
 */
export default function ScopeSwitch({ scope, onScopeChange, canSeeScope = true, subDealerCount = null }) {
  const SCOPES = useMemo(
    () =>
      ALL_SCOPES.filter((s) => {
        // subDealerCount henüz yüklenmediyse (null) gizleme — veri gelince
        // segment sayısı değişip kaydırma animasyonu zıplamasın diye
        // yalnızca kesin 0 olduğunda kaldırılır.
        if (s.needsSubDealer && subDealerCount === 0) return false;
        return true;
      }),
    [subDealerCount]
  );
  const activeIndex = Math.max(0, SCOPES.findIndex((s) => s.key === scope));
  const colCount = Math.max(1, SCOPES.length);

  if (!canSeeScope || SCOPES.length <= 1) return null;

  return (
    <div
      className="relative grid w-full sm:w-auto shrink-0 bg-gray-100 rounded-xl p-1"
      style={{ gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))` }}
    >
      <div
        className="absolute top-1 bottom-1 rounded-lg bg-white border border-gray-200 shadow-sm transition-all duration-300 ease-out"
        style={{
          width: `calc(${100 / colCount}% - 4px)`,
          left: `calc(${activeIndex * (100 / colCount)}% + 2px)`,
        }}
      />
      {SCOPES.map((s) => (
        <button
          key={s.key}
          type="button"
          onClick={() => onScopeChange(s.key)}
          aria-pressed={scope === s.key}
          className={`relative z-10 flex items-center justify-center px-3 sm:px-4 py-1.5 rounded-lg text-xs sm:text-sm font-SemiBold whitespace-nowrap transition-colors duration-200 ${
            scope === s.key ? "text-gray-900" : "text-gray-500 hover:text-gray-700"
          }`}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
